import { render, staticRenderFns } from "./TambahProvinsi.vue?vue&type=template&id=61cfcaee&scoped=true"
import script from "./TambahProvinsi.vue?vue&type=script&lang=js"
export * from "./TambahProvinsi.vue?vue&type=script&lang=js"
import style0 from "./TambahProvinsi.vue?vue&type=style&index=0&id=61cfcaee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cfcaee",
  null
  
)

export default component.exports